<div class="social-container">
  @if (LinkedIn) {
    <a mat-mini-fab color="white" class="color" href='{{LinkedIn}}' target='_blank' aria-label="LinkedIn">
      <fa-icon size="lg" [icon]="faLinkedin"></fa-icon>
    </a>
  }
  @if (Instagram) {
    <a mat-mini-fab color="white" class="color" href='{{Instagram}}' target='_blank' aria-label="Instagram">
      <fa-icon size="lg"  [icon]="faInstagram"></fa-icon>
    </a>
  }
  @if (Facebook) {
    <a mat-mini-fab color="white" class="color" href='{{Facebook}}' target='_blank' aria-label="Instagram">
      <fa-icon size="lg"  [icon]="faFacebook"></fa-icon>
    </a>
  }
  @if (GitHub) {
    <a mat-mini-fab color="white" class="color" href='{{GitHub}}' target='_blank' aria-label="GitHub">
      <fa-icon size="lg"  [icon]="faGithub"></fa-icon>
    </a>
  }
  @if (Stackoverflow) {
    <a mat-mini-fab color="white" class="color" href='{{Stackoverflow}}' target='_blank' aria-label="Stackoverflow">
      <fa-icon size="lg" [icon]="faStackoverflow"></fa-icon>
    </a>
  }
  @if (Web) {
    <a mat-mini-fab color="white" class="color" href='{{Web}}' aria-label="Website" target='_blank'>
      <fa-icon size="lg" [icon]="faGlobeEurope"></fa-icon>
    </a>
  }
  @if (Mail) {
    <a mat-mini-fab color="white" class="color" href='mailto:{{Mail}}' aria-label="Email" >
      <fa-icon size="lg" [icon]="faEnvelope"></fa-icon>
    </a>
  }
</div>